import axiosInstance from './AxiosInstance';

const API_URL = 'tuition';

export const getTuitions = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching tuitions', error);
        throw error;
    }
};

export const getTuitionsByEmailYear = async (email,year) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/${email}/${year}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching tuition with email ${email}, ${year}`, error);
        throw error;
    }
};

export const createTuition = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/create`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating job', error);
        throw error;
    }
};

export const updateTuition = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, data);
        return response.data;
    } catch (error) {
        console.error(`Error updating tuition `, error);
        throw error;
    }
};

export const deleteTuition = async (email,year) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { email, year });
        return response.data;
    } catch (error) {
        console.error(`Error deleting tuition with id ${email}, ${year}`, error);
        throw error;
    }
};

export const addHistory = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/history/add`,data);
        return response.data;
    } catch (error) {
        console.error(`Error adding history`, error);
        throw error;
    }
};

export const updateHistory = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/history/update`,data);
        return response.data;
    } catch (error) {
        console.error(`Error updateing history`, error);
        throw error;
    }
};

export const importExcel = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/import-excel`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        return response.data;
    } catch (error) {
        console.error('Error import-excel mte', error);
        throw error;
    }
};
